/*eslint-disable*/
import axios from 'axios';
import {baseApiUrl} from "../../../config.js";
import { loadModules } from 'esri-loader';

const state = {
  mapWebScene: null,
  mapView: null,
  initialComments: [],
  commentReplies: [],
  currentCommentId: null,
  currentComment: null,
  currentReplies: [],
  userName: null,
  replyAttachments: [],
  staticCommentLayerId: "comment-graphics",
  staticCommentLayerTitle: "User Comments",
  mapWebSceneLoadFlag: null,
  disciplineList: [
    {
      code: "civil",
      label: "Civil"
    },
    {
      code: "structural",
      label: "Structural"
    },
    {
      code: "mech_elec_hyd_fire",
      label: "Mechanical,  Electrical, Hydraulics & Fire"
    },
    {
      code: "transport_planning",
      label: "Transport Planning"
    },
    {
      code: "rail_systems",
      label: "Rail Systems"
    },
    {
      code: "construction",
      label: "Construction"
    },
    {
      code: "de_gis",
      label: "D&E and GIS"
    },
  ],
  emailList: [],
  emails: {
    civil: [
      {
        value: "Melanie.Gostelow@arcadis.com",
        label: "Melanie.Gostelow@arcadis.com"
      },
      {
        value: "Jeremy.Hopson@arcadis.com",
        label: "Jeremy.Hopson@arcadis.com"
      },
      {
        value: "Jermaine.Seco@arcadis.com",
        label: "Jermaine.Seco@arcadis.com"
      },
      {
        value: "Vivek.Sainju@arcadis.com",
        label: "Vivek.Sainju@arcadis.com"
      },
      {
        value: "Nicole.vukic@arcadis.com",
        label: "Nicole.vukic@arcadis.com"
      },
      {
        value: "Johanna.Mendoza@arcadis.com",
        label: "Johanna.Mendoza@arcadis.com"
      },
    ],
    structural: [
      {
        value: "Jordan.Scott@arcadis.com",
        label: "Jordan.Scott@arcadis.com"
      },
      {
        value: "Ramesh.Watson@arcadis.com",
        label: "Ramesh.Watson@arcadis.com"
      },
      {
        value: "Daniel.thomy@arcadis.com",
        label: "Daniel.thomy@arcadis.com"
      },
      {
        value: "Kevin.Hunt@arcadis.com",
        label: "Kevin.Hunt@arcadis.com"
      },
      {
        value: "Ken.maxwell@arcadis.com",
        label: "Ken.maxwell@arcadis.com"
      },
      {
        value: "Andrew.Thompson@arcadis.com",
        label: "Andrew.Thompson@arcadis.com"
      },
      {
        value: "Johanna.Mijares@arcadis.com",
        label: "Johanna.Mijares@arcadis.com"
      },
    ],
    mech_elec_hyd_fire: [
      {
        value: "stuart.bowling@arcadis.com",
        label: "stuart.bowling@arcadis.com"
      },
      {
        value: "paul.jansen@arcadis.com",
        label: "paul.jansen@arcadis.com"
      },
      {
        value: "David.Casburn@arcadis.com",
        label: "David.Casburn@arcadis.com"
      },
      {
        value: "Kakoli.Das@arcadis.com",
        label: "Kakoli.Das@arcadis.com"
      },
      {
        value: "Max.Hough@arcadis.com",
        label: "Max.Hough@arcadis.com"
      },
      {
        value: "Costa.Vasili@arcadis.com",
        label: "Costa.Vasili@arcadis.com"
      },
    ],
    transport_planning: [
      {
        value: "Nicole.vukic@arcadis.com",
        label: "Nicole.vukic@arcadis.com"
      },
      {
        value: "Bailey.byrnes@arcadis.com",
        label: "Bailey.byrnes@arcadis.com"
      },
      {
        value: "Ghaith.farfour@arcadis.com",
        label: "Ghaith.farfour@arcadis.com"
      },
      {
        value: "Wendy.Hu1@arcadis.com",
        label: "Wendy.Hu1@arcadis.com"
      },
      {
        value: "John.j.robertson@arcadis.com",
        label: "John.j.robertson@arcadis.com"
      },
      {
        value: "Russell.gilbert@arcadis.com",
        label: "Russell.gilbert@arcadis.com"
      },
      {
        value: "William.macleod@arcadis.com",
        label: "William.macleod@arcadis.com"
      },
      {
        value: "Bryony.Cooper@arcadis.com",
        label: "Bryony.Cooper@arcadis.com"
      },
      {
        value: "Anthony.Fransos@arcadis.com",
        label: "Anthony.Fransos@arcadis.com"
      },
      {
        value: "Olga.Feldman@arcadis.com",
        label: "Olga.Feldman@arcadis.com"
      },
      {
        value: "Kung.Nigarnjanagool@arcadis.com",
        label: "Kung.Nigarnjanagool@arcadis.com"
      },
      {
        value: "Roy.Conrad@arcadis.com",
        label: "Roy.Conrad@arcadis.com"
      },
    ],
    rail_systems: [
      {
        value: "Varghese.Alex@arcadis.com",
        label: "Varghese.Alex@arcadis.com"
      },
      {
        value: "Matthew.Ellison@arcadis.com",
        label: "Matthew.Ellison@arcadis.com"
      },
      {
        value: "Trina.Chan@arcadis.com",
        label: "Trina.Chan@arcadis.com"
      },
      {
        value: "Tanya.Norton@arcadis.com",
        label: "Tanya.Norton@arcadis.com"
      },
      {
        value: "richard.i.bonner@arcadis.com",
        label: "richard.i.bonner@arcadis.com"
      },
    ],
    construction: [
      {
        value: "rob.smerdon@archservices.com.au",
        label: "rob.smerdon@archservices.com.au"
      },
      {
        value: "aaron.bik@archservices.com.au",
        label: "aaron.bik@archservices.com.au"
      },
      {
        value: "Trina.Chan@arcadis.com",
        label: "Trina.Chan@arcadis.com"
      },
      {
        value: "Dan.Faries@arcadis.com",
        label: "Dan.Faries@arcadis.com"
      },
      {
        value: "Harry.beertsen@arcadis.com",
        label: "Harry.beertsen@arcadis.com"
      },
    ],
    de_gis: [
      {
        value: "Steven.Coyle@arcadis.com",
        label: "Steven.Coyle@arcadis.com"
      },
      {
        value: "Liam.Corscadden@arcadis.com",
        label: "Liam.Corscadden@arcadis.com"
      },
      {
        value: "Jason.Grandin@arcadis.com",
        label: "Jason.Grandin@arcadis.com"
      },
      {
        value: "Rittick.Borah@arcadis.com",
        label: "Rittick.Borah@arcadis.com"
      },
      {
        value: "Nalin.Senevirathne@arcadis.com",
        label: "Nalin.Senevirathne@arcadis.com"
      },
      {
        value: "Emily.Hurry@arcadis.com",
        label: "Emily.Hurry@arcadis.com"
      },
      {
        value: "Leonardo.Quines@arcadis.com",
        label: "Leonardo.Quines@arcadis.com"
      },
      {
        value: "Sheena.Verdad@arcadis.com",
        label: "Sheena.Verdad@arcadis.com"
      },
    ]
  },
  defaultEmails: [
    {
      value: "leonardo.quines@arcadis.com",
      label: "leonardo.quines@arcadis.com"
    },
    {
      value: "sheena.verdad@arcadis.com",
      label: "sheena.verdad@arcadis.com"
    },
    {
      value: "Rittick.Borah@arcadis.com",
      label: "Rittick.Borah@arcadis.com"
    },
    {
      value: "Nalin.Senevirathne@arcadis.com",
      label: "Nalin.Senevirathne@arcadis.com"
    }
  ]
}

function initialState() {
  return {
    mapWebScene: null,
    mapView: null,
    initialComments: [],
    commentReplies: [],
    currentCommentId: null,
    currentComment: null,
    currentReplies: [],
    userName: null,
    replyAttachments: [],
    staticCommentLayerId: "comment-graphics",
    staticCommentLayerTitle: "User Comments",
    mapWebSceneLoadFlag: null,
    disciplineList: [
      {
        code: "civil",
        label: "Civil"
      },
      {
        code: "structural",
        label: "Structural"
      },
      {
        code: "mech_elec_hyd_fire",
        label: "Mechanical,  Electrical, Hydraulics & Fire"
      },
      {
        code: "transport_planning",
        label: "Transport Planning"
      },
      {
        code: "rail_systems",
        label: "Rail Systems"
      },
      {
        code: "construction",
        label: "Construction"
      },
      {
        code: "de_gis",
        label: "D&E and GIS"
      },
    ],
    emailList: [],
    emails: {
      civil: [
        {
          value: "Melanie.Gostelow@arcadis.com",
          label: "Melanie.Gostelow@arcadis.com"
        },
        {
          value: "Jeremy.Hopson@arcadis.com",
          label: "Jeremy.Hopson@arcadis.com"
        },
        {
          value: "Jermaine.Seco@arcadis.com",
          label: "Jermaine.Seco@arcadis.com"
        },
        {
          value: "Vivek.Sainju@arcadis.com",
          label: "Vivek.Sainju@arcadis.com"
        },
        {
          value: "Nicole.vukic@arcadis.com",
          label: "Nicole.vukic@arcadis.com"
        },
        {
          value: "Johanna.Mendoza@arcadis.com",
          label: "Johanna.Mendoza@arcadis.com"
        },
      ],
      structural: [
        {
          value: "Jordan.Scott@arcadis.com",
          label: "Jordan.Scott@arcadis.com"
        },
        {
          value: "Ramesh.Watson@arcadis.com",
          label: "Ramesh.Watson@arcadis.com"
        },
        {
          value: "Daniel.thomy@arcadis.com",
          label: "Daniel.thomy@arcadis.com"
        },
        {
          value: "Kevin.Hunt@arcadis.com",
          label: "Kevin.Hunt@arcadis.com"
        },
        {
          value: "Ken.maxwell@arcadis.com",
          label: "Ken.maxwell@arcadis.com"
        },
        {
          value: "Andrew.Thompson@arcadis.com",
          label: "Andrew.Thompson@arcadis.com"
        },
        {
          value: "Johanna.Mijares@arcadis.com",
          label: "Johanna.Mijares@arcadis.com"
        },
      ],
      mech_elec_hyd_fire: [
        {
          value: "stuart.bowling@arcadis.com",
          label: "stuart.bowling@arcadis.com"
        },
        {
          value: "paul.jansen@arcadis.com",
          label: "paul.jansen@arcadis.com"
        },
        {
          value: "David.Casburn@arcadis.com",
          label: "David.Casburn@arcadis.com"
        },
        {
          value: "Kakoli.Das@arcadis.com",
          label: "Kakoli.Das@arcadis.com"
        },
        {
          value: "Max.Hough@arcadis.com",
          label: "Max.Hough@arcadis.com"
        },
        {
          value: "Costa.Vasili@arcadis.com",
          label: "Costa.Vasili@arcadis.com"
        },
      ],
      transport_planning: [
        {
          value: "Nicole.vukic@arcadis.com",
          label: "Nicole.vukic@arcadis.com"
        },
        {
          value: "Bailey.byrnes@arcadis.com",
          label: "Bailey.byrnes@arcadis.com"
        },
        {
          value: "Ghaith.farfour@arcadis.com",
          label: "Ghaith.farfour@arcadis.com"
        },
        {
          value: "Wendy.Hu1@arcadis.com",
          label: "Wendy.Hu1@arcadis.com"
        },
        {
          value: "John.j.robertson@arcadis.com",
          label: "John.j.robertson@arcadis.com"
        },
        {
          value: "Russell.gilbert@arcadis.com",
          label: "Russell.gilbert@arcadis.com"
        },
        {
          value: "William.macleod@arcadis.com",
          label: "William.macleod@arcadis.com"
        },
        {
          value: "Bryony.Cooper@arcadis.com",
          label: "Bryony.Cooper@arcadis.com"
        },
        {
          value: "Anthony.Fransos@arcadis.com",
          label: "Anthony.Fransos@arcadis.com"
        },
        {
          value: "Olga.Feldman@arcadis.com",
          label: "Olga.Feldman@arcadis.com"
        },
        {
          value: "Kung.Nigarnjanagool@arcadis.com",
          label: "Kung.Nigarnjanagool@arcadis.com"
        },
        {
          value: "Roy.Conrad@arcadis.com",
          label: "Roy.Conrad@arcadis.com"
        },
      ],
      rail_systems: [
        {
          value: "Varghese.Alex@arcadis.com",
          label: "Varghese.Alex@arcadis.com"
        },
        {
          value: "Matthew.Ellison@arcadis.com",
          label: "Matthew.Ellison@arcadis.com"
        },
        {
          value: "Trina.Chan@arcadis.com",
          label: "Trina.Chan@arcadis.com"
        },
        {
          value: "Tanya.Norton@arcadis.com",
          label: "Tanya.Norton@arcadis.com"
        },
        {
          value: "richard.i.bonner@arcadis.com",
          label: "richard.i.bonner@arcadis.com"
        },
      ],
      construction: [
        {
          value: "rob.smerdon@archservices.com.au",
          label: "rob.smerdon@archservices.com.au"
        },
        {
          value: "aaron.bik@archservices.com.au",
          label: "aaron.bik@archservices.com.au"
        },
        {
          value: "Trina.Chan@arcadis.com",
          label: "Trina.Chan@arcadis.com"
        },
        {
          value: "Dan.Faries@arcadis.com",
          label: "Dan.Faries@arcadis.com"
        },
        {
          value: "Harry.beertsen@arcadis.com",
          label: "Harry.beertsen@arcadis.com"
        },
      ],
      de_gis: [
        {
          value: "Steven.Coyle@arcadis.com",
          label: "Steven.Coyle@arcadis.com"
        },
        {
          value: "Liam.Corscadden@arcadis.com",
          label: "Liam.Corscadden@arcadis.com"
        },
        {
          value: "Jason.Grandin@arcadis.com",
          label: "Jason.Grandin@arcadis.com"
        },
        {
          value: "Rittick.Borah@arcadis.com",
          label: "Rittick.Borah@arcadis.com"
        },
        {
          value: "Nalin.Senevirathne@arcadis.com",
          label: "Nalin.Senevirathne@arcadis.com"
        },
        {
          value: "Emily.Hurry@arcadis.com",
          label: "Emily.Hurry@arcadis.com"
        },
        {
          value: "Leonardo.Quines@arcadis.com",
          label: "Leonardo.Quines@arcadis.com"
        },
        {
          value: "Sheena.Verdad@arcadis.com",
          label: "Sheena.Verdad@arcadis.com"
        },
      ]
    },
    defaultEmails: [
      {
        value: "leonardo.quines@arcadis.com",
        label: "leonardo.quines@arcadis.com"
      },
      {
        value: "sheena.verdad@arcadis.com",
        label: "sheena.verdad@arcadis.com"
      },
      {
        value: "Rittick.Borah@arcadis.com",
        label: "Rittick.Borah@arcadis.com"
      },
      {
        value: "Nalin.Senevirathne@arcadis.com",
        label: "Nalin.Senevirathne@arcadis.com"
      }
    ]
  }
}
const mutations = {
  saveMapWebScene(state, data) {
    state.mapWebScene = data
  },
  saveMapView(state, data) {
    state.mapView = data
  },
  saveUserName(state, data) {
    state.userName = data
  },
  insertInitialComments(state, payload) {
    console.log("insertInitialComments");
    console.log(payload);
    state.initialComments.push(payload)
  },
  resetInitialComments(state) {
    state.initialComments = []
  },
  resetCommentReplies(state) {
    state.commentReplies = []
  },
  insertCommentReplies(state, payload) {
    state.commentReplies.push(payload)
  },
  setCurrentCommentId(state, payload) {
    state.currentCommentId = payload
  },
  setCurrentComment(state, payload) {
    state.currentComment = payload
  },
  setCurrentReplies(state, payload) {
    payload.replies.forEach(item=>{
      state.currentReplies.push(item)
    })
  },
  clearCurrentReplies(state) {
    state.currentReplies = []
  },
  addNewReply(state, payload) {
    var objectId = payload.objectId
    var currentReplies = state.commentReplies.filter(obj=>obj.objectId == objectId)
    if (currentReplies.length) {
      currentReplies[0].replies.push(payload.reply)
    }
    else {
      var commentReply = {
        decision: payload.decision,
        objectId: objectId,
        replies: [payload.reply]
      }
      console.log(commentReply);
      state.commentReplies.push(commentReply)
    }
  },
  finalizeComment(state, payload) {
    var currentComment = state.initialComments.filter(obj=>obj.objectId == payload.objectId)
    currentComment[0].approvalStatus = payload.decision?"Approved":currentComment.approvalStatus
    console.log(currentComment);
  },
  clearAttachments(state) {
    state.replyAttachments = []
  },
  addAttachment(state, payload) {
    state.replyAttachments.push(payload)
  },
  removeAttachment(state, index) {
    state.replyAttachments.splice(index,1)
  },
  setMapWebSceneLoadFlag(state, payload) {
    state.mapWebSceneLoadFlag = payload
  },
  setEmailList(state, payload) {
    state.emailList = state.emails[payload]
    // for dev testing
    // state.defaultEmails.forEach(item=>{
    //   state.emailList.push(item)
    // })
  }
}

const actions = {
  async fetchCommentReplies ({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject) {
      let url = baseApiUrl + "fetchReplies"
      let data    = {
        commentIds: payload.objectIds
      }
      let config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        commit("resetCommentReplies")
        result.data.forEach((item,index) => {
          commit('insertCommentReplies', item);
        })
        resolve();
      }).catch(error=>{
        reject(error);
      })
    })
  },
  setCurrentCommentDetails({state, commit}, payload) {
    commit("setCurrentCommentId", payload)
    var currentComment = state.initialComments.filter(obj=>obj.objectId == payload)
    console.log(currentComment);
    if (currentComment.length) {
      commit("setCurrentComment", currentComment)
    }
    var currentReplies = state.commentReplies.filter(obj=>obj.objectId == payload)
    commit("clearCurrentReplies")
    if (currentReplies.length) {
      commit("setCurrentReplies", currentReplies[0])
    }
    console.log("Current Comment: ");
    console.log(state.currentComment);
    console.log("Current Replies: ");
    console.log(state.currentReplies);
  },
  fetchCommentLayer({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject) {
      // const vue = document.getElementById("map").__vue__
      // const view = vue.view
      var url = baseApiUrl + "fetchComments"
      var data = {}
      var config = {
        responseType: 'json'
      }
      axios.post(url, data, config).then(response=>{
        var commentsList = response.data.features
        var commentsCount = 0;
        loadModules([
          "esri/layers/GraphicsLayer",
          "esri/Graphic",
          "esri/PopupTemplate"
        ],{ css: true })
        .then(([
          GraphicsLayer,
          Graphic,
          PopupTemplate
        ]) => {
          var commentGraphicsLayer = new GraphicsLayer({
            id: state.staticCommentLayerId,
            // title: state.staticCommentLayerTitle
          });
          const popupTemplate = new PopupTemplate({
            title: "Comment Details",
            content: [{
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "id",
                  label: "Object ID"
                },
                {
                  fieldName: "commenterName",
                  label: "Commented by"
                },
                {
                  fieldName: "details",
                  label: "Comment"
                },
                {
                  fieldName: "discipline",
                  label: "Discipline"
                },
                {
                  fieldName: "dueDate",
                  label: "Due Date"
                },
                {
                  fieldName: "date",
                  label: "Date"
                },
                {
                  fieldName: "approvalState",
                  label: "Approval Status"
                },
                {
                  fieldName: "priority",
                  label: "Priority"
                }
              ]
            }]
          });
          commentsList.forEach(comment=>{
            var commentEntry = new Graphic({
              geometry: {
                type: "point",
                latitude: comment.geometry.latitude,
                longitude:comment.geometry.longitude,
                z: comment.geometry.height
              },
              attributes: comment.attributes,
              symbol: {
                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                url: "DefaultMarker.png",
                width: 20
                // type: "point-3d",
                // symbolLayers: [{
                //   type: "object",
                //   anchor: "origin",
                //   width: 3,
                //   material: {
                //     color: [198, 235, 52, 1]
                //   }
                // }]
              },
              popupTemplate: popupTemplate
            });

            commentGraphicsLayer.graphics.push(commentEntry)
          })
          // for (const comment of commentsList) {
          //   var commentEntry = new Graphic({
          //     geometry: {
          //       type: "point",
          //       latitude: comment.geometry.latitude,
          //       longitude:comment.geometry.longitude,
          //       z: comment.geometry.height
          //     },
          //     attributes: comment.attributes,
          //     symbol: {
          //       type: "point-3d",
          //       symbolLayers: [{
          //         type: "object",
          //         anchor: "origin",
          //         width: 5,
          //         material: {
          //           color: [198, 235, 52, 1]
          //         }
          //       }]
          //     },
          //     popupTemplate: popupTemplate
          //   });
          //
          //   commentGraphicsLayer.graphics.push(commentEntry)
          // }
            resolve(commentGraphicsLayer)
        })
      })
    });
  }
}

const getters = {}



export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
